import { useLocation } from 'react-router-dom';
import {
  LayoutMobileContainer,
  LayoutMobileContent,
} from './LayoutMobile.styles';
import LayoutMobileHeader from './LayoutMobileHeader';
import LayoutMobileFooter from './LayoutMobileFooter';

// @ts-expect-error TS7031 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
const LayoutMobile = ({ children }) => {
  const { pathname } = useLocation();

  const isLoginPage = pathname.includes('login');

  return (
    <LayoutMobileContainer>
      <LayoutMobileHeader />

      <LayoutMobileContent>{children}</LayoutMobileContent>

      {!isLoginPage && <LayoutMobileFooter />}
    </LayoutMobileContainer>
  );
};

export default LayoutMobile;
